/**
 * @returns {Object}
 */
function parseCookies() {
  // cookies are separated by '; '
  const cookies = document.cookie.split('; ');

  const ret = {};
  for (let i = cookies.length - 1; i >= 0; i -= 1) {
    const el = cookies[i].split('=');
    ret[el[0]] = el[1];
  }

  return ret;
}

export default parseCookies;
